/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ログインリクエスト
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * consoleログイン時に指定するID
     * @type {string}
     * @memberof LoginRequest
     */
    consoleUserId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    otpToken: string;
}

export function LoginRequestFromJSON(json: any): LoginRequest {
    return LoginRequestFromJSONTyped(json, false);
}

export function LoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consoleUserId': json['console_user_id'],
        'password': json['password'],
        'token': json['token'],
        'otpToken': json['otp_token'],
    };
}

export function LoginRequestToJSON(value?: LoginRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'console_user_id': value.consoleUserId,
        'password': value.password,
        'token': value.token,
        'otp_token': value.otpToken,
    };
}


